import React from "react";
import AppButton, { AppButtonProps } from "./AppButton";
import { SxProps, Theme } from "@mui/material";

interface SubmitButtonProps extends Omit<
  AppButtonProps,
  "children" | "type" | "isLoading"
> {
  title: string;
  loading?: boolean;
  sx?: SxProps<Theme>;
}

const SubmitButton: React.FC<SubmitButtonProps> = ({
  title,
  loadingText = "Please wait...",
  loading = false,
  disabled = false,
  startIcon,
  endIcon,
  variant = "gradient",
  color = "primary",
  fullWidth = true,
  pill = false,
  onClick,
  sx = {},
  ...props
}) => {
  return (
    <AppButton
      type="submit"
      onClick={onClick}
      isLoading={loading}
      loadingText={loadingText}
      disabled={disabled}
      variant={variant}
      color={color}
      fullWidth={fullWidth}
      size="medium"
      pill={pill}
      startIcon={startIcon}
      endIcon={endIcon}
      sx={{
        fontSize: "1rem",
        ...sx,
      }}
      {...props}
    >
      {title}
    </AppButton>
  );
};

export default SubmitButton;
